import React from 'react';
import { useIntl } from 'react-intl';

import { withStyles, WithStyles } from '@material-ui/core/styles';

import { mobilePhoneMask } from 'ui-utils';

import { useStyles } from './Contact.useStyles';
import ContactIcon from './ContactIcon';
import messages from './messages';

interface ContactProps extends WithStyles<typeof useStyles> {
  clickable?: boolean;
  contact: any;
  lastUpdate?: string;
}

const Contact: React.FC<ContactProps> = ({ classes, clickable, contact, lastUpdate }) => {
  const { formatMessage } = useIntl();

  if (!contact || !contact.value) {
    return null;
  }

  const { type, value } = contact;
  const prefix = type === 'email' ? 'mailto' : 'tel';
  const contactValue = type === 'sms' || type === 'voice' ? mobilePhoneMask(value) : value;

  if (clickable) {
    return (
      <a
        style={{ color: 'initial', textDecoration: 'none' }}
        href={`${prefix}:${value.replace('+1 ', '')}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <ContactIcon className={classes.icon} type={type} />
        {contactValue}
      </a>
    );
  }

  return (
    <div>
      <ContactIcon className={classes.icon} type={type} />
      {`${contactValue} ${lastUpdate ? ` - ${formatMessage(messages.updatedOn)} ${lastUpdate}` : ''}`}
    </div>
  );
};

export default withStyles(useStyles)(Contact);
